import React, { useEffect, useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MDButton from "components/MDButton";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

type Props = {
  onUpload: (file: File) => void;
  newUploadLabel: string;
  updateUploadLabel: string;
  initialUrl?: string | File;
  noFilelabel: string;
  seeFileLabel: string;
};

function UploadField({ onUpload, newUploadLabel, updateUploadLabel, initialUrl, noFilelabel, seeFileLabel }: Props) {
  const [selectedFileName, setSelectedFileName] = useState<string | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSelectedFileName(file.name);
    setPreviewUrl(URL.createObjectURL(file));
    onUpload(file);
  };

  useEffect(() => {
    setSelectedFileName(null);
    setPreviewUrl(null);
  }, [initialUrl]);

  const displayUrl = previewUrl || (typeof initialUrl === "string" ? initialUrl : null);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
        {!previewUrl && !initialUrl && (
          <span style={{ color: "#888", fontSize: "16px" }}>
            {noFilelabel}
          </span>
        )}
        {!previewUrl && initialUrl && typeof initialUrl === "string" && (
          <MDButton
            component="label"
            color="success"
            startIcon={<OpenInNewIcon />}
            onClick={() => window.open(initialUrl, "_blank")}
          >
            {seeFileLabel}
          </MDButton>
        )}
        {selectedFileName && (
          <span style={{ color: "#888", fontSize: "14px", fontStyle: "italic" }}>
            {selectedFileName}
          </span>
        )}
        <label>
          <MDButton
            variant="gradient"
            component="label"
            color="info"
            startIcon={<CloudUploadIcon />}
          >
            {initialUrl || selectedFileName ? updateUploadLabel : newUploadLabel}
            <input type="file" accept="image/*" hidden onChange={handleChange} />
          </MDButton>
        </label>
      </div>
      {displayUrl && (
        <img
          src={displayUrl}
          alt="aperçu"
          style={{
            width: 80,
            height: 80,
            objectFit: "cover",
            borderRadius: 8,
            border: "1px solid #ddd",
          }}
        />
      )}
    </div>
  );
}

export default UploadField;
